export default "__VITE_ASSET__Chd2_PjH__"